// extracted by mini-css-extract-plugin
module.exports = {"stepper":"stepnumber_stepper__F0hvX"};